import { ThunkDispatch } from "@reduxjs/toolkit";
import { connect, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { ItemImage } from "../../reducers/itemRemoval";

import ItemRemovalEditFormEmpty from "./ItemRemovalEditFormEmpty";
import ItemRemovalEditFormSome from "./ItemRemovalEditFormSome";

// State型定義
interface RootState {
  itemRemoval: {
    itemImages: ItemImage[];
    [key: string]: any;
  };
  [key: string]: any;
}

// mapStateToPropsの型定義
function mapStateToProps(state: RootState) {
  return { ...state.itemRemoval };
}

// コンポーネントのProps型定義
interface ItemRemovalFormProps {
  itemImages: ItemImage[];
}

const ItemRemovalForm = (props: ItemRemovalFormProps) => {
  const { itemImages } = props;
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const navigate = useNavigate();

  return (
    <>
      {itemImages.length === 0 && <ItemRemovalEditFormEmpty />}
      {itemImages.length !== 0 && <ItemRemovalEditFormSome />}
    </>
  );
};

export default connect(mapStateToProps)(ItemRemovalForm);